<template>
  <nav
    class="breadcrumbs"
    :class="{ [$class('loading')]: state === 'loading' }"
    :aria-label="$string('general.breadcrumbs.label')"
  >
    <ol class="breadcrumbs__list-element">
      <li class="breadcrumbs__list-item">
        <a
          class="breadcrumbs__link"
          :href="$variable('routes.root')"
          v-text="$string('general.breadcrumbs.home')"
        />
      </li>

      <li
        v-if="hasAncestor || hasBackup"
        class="breadcrumbs__list-item"
      >
        <a
          class="breadcrumbs__link"
          :href="ancestorUrl || backupUrl"
          v-text="ancestorTitle || backupTitle"
        />
      </li>

      <li
        v-if="title"
        class="breadcrumbs__list-item"
      >
        <span
          class="breadcrumbs__text"
          v-text="title"
        />
      </li>

      <template
        v-for="(extra, index) of extras"
        :key="index"
      >
        <li
          v-if="extra.title"
          class="breadcrumbs__list-item"
        >
          <component
            :is="extra.url ? 'a' : 'span'"
            :href="extra.url ? extra.url : null"
            :class="extra.url ? 'breadcrumbs__link' : 'breadcrumbs__text'"
          >
            {{ extra.title }}
          </component>
        </li>
      </template>
    </ol>
  </nav>
</template>

<script>

/**
 * Vue: Breadcrumbs (breadcrumbs)
 * -----------------------------------------------------------------------------
 * Breadcrumbs navigation links.
 *
 * @param {String} ancestorTitle - Title of ancestor, e.g. collection title if
 * product is in a collection.
 * @param {String} ancestorUrl - URL of ancestor, this avoids complicating the
 * breadcrumb component by making additional queries to load ancestor data.
 * @param {String} backupTitle - Title of backup
 * @param {String} backupUrl - URL of backup
 * @param {String} state - Loading state of parent component.
 * @param {String} title - Title displayed for current page.
 * @param {Array} extras - Extra data to be added to the breadcrumb path.
 */

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Breadcrumbs',

  props: {
    ancestorTitle: {
      type: String,
      default: '',
    },
    ancestorUrl: {
      type: String,
      default: '',
    },
    backupTitle: {
      type: String,
      default: '',
    },
    backupUrl: {
      type: String,
      default: '',
    },
    state: {
      type: String,
      default: 'loading',
    },
    title: {
      type: String,
      default: '',
    },
    extras: {
      type: Array,
      default: () => [],
    },
  },

  computed: {

    /**
     * Check if ancestor exists
     * @returns {Boolean}
     */
    hasAncestor() {
      return this.ancestorTitle && this.ancestorUrl
    },

    /**
     * Check if backup collection exists
     * @returns {Boolean}
     */
    hasBackup() {
      return this.backupTitle && this.backupUrl
    },
  },

  methods: {

    /**
     * Get element type based on whether URL has been provided.
     * @param {Object} data
     * @returns {String}
     */
    getType(data) {
      if (data.url) {
        return 'a'
      }

      return 'span'
    },

    /**
     * Get URL from data.
     * @param {Object} data
     * @returns {String}
     */
    getHref(data) {
      if (data.url) {
        return data.url
      }

      return null
    },
  },
}
</script>

<style lang="scss">
@import './breadcrumbs';
</style>
